/**
 *天气图标
 */
//白天晴
import CHINA from '@/assets/shipIcons/mipmap-xxxhdpi/c001.png';
import Japan from '@/assets/shipIcons/mipmap-xxxhdpi/c104.png';
import Korea from '@/assets/shipIcons/mipmap-xxxhdpi/c230.png';
import Argentina from '@/assets/shipIcons/mipmap-xxxhdpi/c010.png';
import Australia from '@/assets/shipIcons/mipmap-xxxhdpi/c013.png';
import Canada from '@/assets/shipIcons/mipmap-xxxhdpi/c038.png';
import Russia from '@/assets/shipIcons/mipmap-xxxhdpi/c164.png';
import America from '@/assets/shipIcons/mipmap-xxxhdpi/c197.png';
import England from '@/assets/shipIcons/mipmap-xxxhdpi/c222.png';
import NewZealand from '@/assets/shipIcons/mipmap-xxxhdpi/c226.png';
import Italy from '@/assets/shipIcons/mipmap-xxxhdpi/c100.png';
import Holland from '@/assets/shipIcons/mipmap-xxxhdpi/c143.png';
import Peru from '@/assets/shipIcons/mipmap-xxxhdpi/c149.png';
import Singapore from '@/assets/shipIcons/mipmap-xxxhdpi/c170.png';
import Malaysia from '@/assets/shipIcons/mipmap-xxxhdpi/c137.png';
import Norway from '@/assets/shipIcons/mipmap-xxxhdpi/c144.png';
import Philippines from '@/assets/shipIcons/mipmap-xxxhdpi/c152.png';
import Liberia from '@/assets/shipIcons/mipmap-xxxhdpi/c113.png';
import Tuvalu from '@/assets/shipIcons/mipmap-xxxhdpi/c193.png';
import FederatedStatesofMicronesia from '@/assets/shipIcons/mipmap-xxxhdpi/c066.png';
import RepublicofVanuatu from '@/assets/shipIcons/mipmap-xxxhdpi/c219.png';

import Panama from '@/assets/shipIcons/mipmap-xxxhdpi/c148.png';
import PapuaNewGuinea from '@/assets/shipIcons/mipmap-xxxhdpi/c151.png';

import Solomon from '@/assets/shipIcons/mipmap-xxxhdpi/c166.png';
import Venezuela from '@/assets/shipIcons/mipmap-xxxhdpi/c200.png';
import Portugal from '@/assets/shipIcons/mipmap-xxxhdpi/c231.png';
import Columbia from '@/assets/shipIcons/mipmap-xxxhdpi/c044.png';

import Sweden from '@/assets/shipIcons/mipmap-xxxhdpi/c169.png';
import Kiribati from '@/assets/shipIcons/mipmap-xxxhdpi/c106.png';
import Uruguay from '@/assets/shipIcons/mipmap-xxxhdpi/c198.png';
import Taiwan from '@/assets/shipIcons/mipmap-xxxhdpi/c225.png';
import Greece from '@/assets/shipIcons/mipmap-xxxhdpi/c079.png';
import Cyprus from '@/assets/shipIcons/mipmap-xxxhdpi/c232.png'
import Other from '@/assets/shipIcons/mipmap-xxxhdpi/c000.png'







let countryStore = new Map();
countryStore.set("CHINA", CHINA);
countryStore.set("China", CHINA);
countryStore.set("china", CHINA);
countryStore.set("中国", CHINA);
countryStore.set("其他", Other);

countryStore.set("Taiwan", Taiwan);
countryStore.set("台湾", Taiwan);
countryStore.set("中国台湾", Taiwan);

countryStore.set("Greece", Greece);
countryStore.set("希腊", Greece);

countryStore.set("Japan", Japan);
countryStore.set("日本", Japan);

countryStore.set("Korea", Korea);
countryStore.set("韩国", Korea);

countryStore.set("Argentina", Argentina);
countryStore.set("阿根廷", Argentina);

countryStore.set("Australia", Australia);
countryStore.set("澳大利亚", Australia);

countryStore.set("Canada", Canada);
countryStore.set("加拿大", Canada);

countryStore.set("Russia", Russia);
countryStore.set("俄罗斯", Russia);

countryStore.set("America", America);
countryStore.set("美国", America);

countryStore.set("England", England);
countryStore.set("英国", England);

countryStore.set("New Zealand", NewZealand);
countryStore.set("新西兰", NewZealand);

countryStore.set("Italy", Italy);
countryStore.set("意大利", Italy);

countryStore.set("Holland", Holland);
countryStore.set("荷兰", Holland);

countryStore.set("Peru", Peru);
countryStore.set("秘鲁", Peru);

countryStore.set("Peru", Singapore);
countryStore.set("新加坡", Singapore);

countryStore.set("Malaysia", Malaysia);
countryStore.set("马来西亚", Malaysia);

countryStore.set("Norway", Norway);
countryStore.set("挪威", Norway);

countryStore.set("Philippines", Philippines);
countryStore.set("菲律宾", Philippines);

countryStore.set("Liberia", Liberia);
countryStore.set("利比里亚", Liberia);

countryStore.set("Tuvalu", Tuvalu);
countryStore.set("图瓦卢", Tuvalu);


countryStore.set("Federated States of Micronesia", FederatedStatesofMicronesia);
countryStore.set("密克罗尼西亚联邦", FederatedStatesofMicronesia);

countryStore.set("Republic of Vanuatu", RepublicofVanuatu);
countryStore.set("瓦努阿图共和国", RepublicofVanuatu);

countryStore.set("Panama", Panama);
countryStore.set("巴拿马", Panama);

countryStore.set("Papua New Guinea", PapuaNewGuinea);
countryStore.set("巴布亚新几内亚", PapuaNewGuinea);

countryStore.set("Solomon", Solomon);
countryStore.set("所罗门", Solomon);

countryStore.set("Venezuela", Venezuela);
countryStore.set("委内瑞拉", Venezuela);

countryStore.set("Portugal", Portugal);
countryStore.set("葡萄牙", Portugal);

countryStore.set("Columbia", Columbia);
countryStore.set("哥伦比亚", Columbia);

countryStore.set("Sweden", Sweden);
countryStore.set("瑞典", Sweden);

countryStore.set("Kiribati", Kiribati);
countryStore.set("基里巴斯", Kiribati);

countryStore.set("Uruguay", Uruguay);
countryStore.set("乌拉圭", Uruguay);

countryStore.set("Cyprus", Cyprus);
countryStore.set("塞浦路斯", Cyprus);




// 第二批数据
import cn from '@/assets/shipIcons/mipmap-xxxhdpi/cn.png'
import jp from '@/assets/shipIcons/mipmap-xxxhdpi/jp.png'
import tw from '@/assets/shipIcons/mipmap-xxxhdpi/tw.png'
import us from '@/assets/shipIcons/mipmap-xxxhdpi/us.png'
import kp from '@/assets/shipIcons/mipmap-xxxhdpi/kp.png'
import es from '@/assets/shipIcons/mipmap-xxxhdpi/es.png'
import cl from '@/assets/shipIcons/mipmap-xxxhdpi/cl.png'
import wnat from '@/assets/shipIcons/mipmap-xxxhdpi/wnat.png'
import pe from '@/assets/shipIcons/mipmap-xxxhdpi/pe.png'
import pa from '@/assets/shipIcons/mipmap-xxxhdpi/pa.png'
import ar from '@/assets/shipIcons/mipmap-xxxhdpi/ar.png'
import nz from '@/assets/shipIcons/mipmap-xxxhdpi/nz.png'
import ca from '@/assets/shipIcons/mipmap-xxxhdpi/ca.png'
import fj from '@/assets/shipIcons/mipmap-xxxhdpi/fj.png'
import pg from '@/assets/shipIcons/mipmap-xxxhdpi/pg.png'
import co from '@/assets/shipIcons/mipmap-xxxhdpi/co.png'
import au from '@/assets/shipIcons/mipmap-xxxhdpi/au.png'
import pm from '@/assets/shipIcons/mipmap-xxxhdpi/pm.png'
import blz from '@/assets/shipIcons/mipmap-xxxhdpi/blz.png'
import ve from '@/assets/shipIcons/mipmap-xxxhdpi/ve.png'
import fr from '@/assets/shipIcons/mipmap-xxxhdpi/fr.png'
import pt from '@/assets/shipIcons/mipmap-xxxhdpi/pt.png'
import mx from '@/assets/shipIcons/mipmap-xxxhdpi/mx.png'
import ki from '@/assets/shipIcons/mipmap-xxxhdpi/ki.png'
import nl from '@/assets/shipIcons/mipmap-xxxhdpi/nl.png'
// import ky from '@/assets/shipIcons/mipmap-xxxhdpi/ky.png'
import hn from '@/assets/shipIcons/mipmap-xxxhdpi/hn.png'
import blnxy from '@/assets/shipIcons/mipmap-xxxhdpi/blnxy.png'
import mh from '@/assets/shipIcons/mipmap-xxxhdpi/mh.png'
import ru from '@/assets/shipIcons/mipmap-xxxhdpi/ru.png'
import ni from '@/assets/shipIcons/mipmap-xxxhdpi/ni.png'
import pl from '@/assets/shipIcons/mipmap-xxxhdpi/pl.png'
import ph from '@/assets/shipIcons/mipmap-xxxhdpi/ph.png'
import fkl from '@/assets/shipIcons/mipmap-xxxhdpi/fkl.png'
import gb from '@/assets/shipIcons/mipmap-xxxhdpi/gb.png'
import no from '@/assets/shipIcons/mipmap-xxxhdpi/no.png'
import lk from '@/assets/shipIcons/mipmap-xxxhdpi/lk.png'
import sv from '@/assets/shipIcons/mipmap-xxxhdpi/sv.png'
// import fo from '@/assets/shipIcons/mipmap-xxxhdpi/fo.png'
import lt from '@/assets/shipIcons/mipmap-xxxhdpi/lt.png'
import sc from '@/assets/shipIcons/mipmap-xxxhdpi/sc.png'
import sb from '@/assets/shipIcons/mipmap-xxxhdpi/sb.png'
import de from '@/assets/shipIcons/mipmap-xxxhdpi/de.png'
// import ck from '@/assets/shipIcons/mipmap-xxxhdpi/ck.png'
import cu from '@/assets/shipIcons/mipmap-xxxhdpi/cu.png'
import th from '@/assets/shipIcons/mipmap-xxxhdpi/th.png'
import bo from '@/assets/shipIcons/mipmap-xxxhdpi/bo.png'
import bf from '@/assets/shipIcons/mipmap-xxxhdpi/bf.png'
import se from '@/assets/shipIcons/mipmap-xxxhdpi/se.png'
import gt from '@/assets/shipIcons/mipmap-xxxhdpi/gt.png'
import lr from '@/assets/shipIcons/mipmap-xxxhdpi/lr.png'
import srb from '@/assets/shipIcons/mipmap-xxxhdpi/srb.png'
import mt from '@/assets/shipIcons/mipmap-xxxhdpi/mt.png'
import my from '@/assets/shipIcons/mipmap-xxxhdpi/my.png'
import cr from '@/assets/shipIcons/mipmap-xxxhdpi/cr.png'
import it from '@/assets/shipIcons/mipmap-xxxhdpi/it.png'
import cura from '@/assets/shipIcons/mipmap-xxxhdpi/cura1.png'

import ua from '@/assets/shipIcons/mipmap-xxxhdpi/ua.png'
import uy from '@/assets/shipIcons/mipmap-xxxhdpi/uy.png'





countryStore.set("中国", cn);
countryStore.set("日本", jp);
countryStore.set("中国台湾", tw);
countryStore.set("美国", us);
countryStore.set("韩国", kp);
countryStore.set("西班牙", es);
countryStore.set("智利", cl);
countryStore.set("瓦努阿图", wnat);
countryStore.set("秘鲁", pe);
countryStore.set("巴拿马", pa);
countryStore.set("阿根廷", ar);
countryStore.set("新西兰", nz);
countryStore.set("加拿大", ca);
countryStore.set("斐济", fj);
countryStore.set("巴布亚新几内亚", pg);
countryStore.set("哥伦比亚", co);
countryStore.set("澳大利亚", au);
countryStore.set("密克罗尼西亚", pm);
countryStore.set("伯利兹", blz);
countryStore.set("委内瑞拉", ve);
countryStore.set("法国", fr);
countryStore.set("葡萄牙", pt);
countryStore.set("墨西哥", mx);
countryStore.set("基里巴斯", ki);
countryStore.set("荷兰", nl);
// countryStore.set("开曼群岛", ky);
countryStore.set("洪都拉斯", hn);
countryStore.set("法属波利尼西亚", blnxy);
countryStore.set("马绍尔", mh);
countryStore.set("俄罗斯", ru);
countryStore.set("尼加拉瓜", ni);
countryStore.set("波兰", pl);
countryStore.set("菲律宾", ph);
countryStore.set("福克兰", fkl);
countryStore.set("英国", gb);
countryStore.set("挪威", no);
countryStore.set("斯里兰卡", lk);
countryStore.set("萨尔瓦多", sv);
// countryStore.set("法罗群岛", fo);
countryStore.set("立陶宛", lt);
countryStore.set("塞舌尔", sc);
countryStore.set("所罗门", sb);
countryStore.set("德国", de);
// countryStore.set("库克群岛", ck);
countryStore.set("古巴", cu);
countryStore.set("泰国", th);
countryStore.set("玻利维亚", bo);
countryStore.set("巴哈马群岛", bf);
countryStore.set("瑞典", se);
countryStore.set("危地马拉", gt);
countryStore.set("利比里亚", lr);
// countryStore.set("库克", ck);
countryStore.set("塞尔维亚", srb);
countryStore.set("马耳他", mt);
countryStore.set("马来西亚", my);
countryStore.set("哥斯达黎加", cr);
countryStore.set("意大利", it);
countryStore.set("库拉索", cura);
countryStore.set("乌克兰", ua);
countryStore.set("乌拉圭", uy);


export default countryStore;


// WEBPACK FOOTER //
// ./src/store/countryStore.js